import React, { Suspense, useState } from "react";
import Router from "./Admin/Routers/router";
import SideBar from "./Admin/Components/LayOut/SideBar";
import { useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import styles from "./Admin/Components/style/style";
import Header from "./Admin/Components/LayOut/Header";
import WarningMessage from "./Admin/Components/LayOut/WarningMessage";

const App = () => {
	const location = useLocation();
	const { pathname } = location;
	const shouldRenderNavbar = ["/login"].includes(pathname);
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);

	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	return (
		<div className="bg-[#F5F5F5] min-h-screen">
			<Toaster
				position="top-center"
				reverseOrder={false}
				toastOptions={{
					duration: 2500,
				}}
				containerStyle={{
					zIndex: 99999999, // For the container
				}}
			/>
			<div className="min-h-screen">
				{!shouldRenderNavbar && (
					<SideBar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
				)}
				<div
					className={`min-h-screen flex flex-col ${
						!shouldRenderNavbar ? "lg:pl-[220px]" : ""
					}`}
				>
					{!shouldRenderNavbar && (
						<Header toggleSidebar={toggleSidebar} />
					)}
					<WarningMessage />
					<div className="flex-1">
						<Suspense
							fallback={
								<div className={`${styles.model} flex justify-center items-center`} >
									<span className="spinner flex justify-center items-center h-screen"></span>
								</div>
							}
						>
							<Router />
						</Suspense>
					</div>
				</div>
			</div>
		</div>
	);
};

export default App;
